import {BaseView} from '../core/view';
import constants from './constants';
import { ApiUtil } from '../utils/api-util';
import { LinkUtil } from '../utils/link';
import {JSErrorTracking} from '../utils/js-error-tracking';
import MobileFilterListView from './mobile-filter-list-view';
import MobileFilterPriceView from './mobile-filter-price-view';
import MobileFilterOptionView from './mobile-filter-option-view';
import { TrackingUtil } from '../utils/tracking';
import { UrlUtil } from "../utils/url-util";

export default BaseView.extend({

    el: '.js-filters-tab',
    urlParams: undefined,
    filtersData: undefined,
    initialActiveFilters: [],
    activeFilters: [],
    listFilterViews: [],
    applyIsActive: false,
    firstLoad: true,
    
    templates: {
        ACTIVE_FILTER_TEMPLATE: require("./templates/mobile-active-filter-template.hbs"),
        ACTIVE_FILTERPRICE_TEMPLATE: require("./templates/mobile-active-filterprice-template.hbs")
    },

    events: {
        'click .js-list-open-dropdown': 'onClickShowDropdown',
        'click .js-active-filter': 'onActiveFilterClick',
        'click .js-active-filterprice': 'onActiveFilterPriceClick',
        'click .js-filter-clear' : 'clearFilters',
        'click .js-filter-apply' : 'applyFilters',
        'click .js-filter-close-error' : 'closeErrorFilter',
        'click .js-filter-button' : 'throwFilterEvent'
    },
    
    initialize: function() {
        var self = this;
        this.urlParams = $('#searchfeed').data('active-querystring');
        this.parseInitialActiveFilters();
        this.initializeFilterData();
        
        
        Backbone.on('applyMobileListFilter', function(data){
            self.toggleActiveFilter(data);
        });
        Backbone.on('applyMobilePriceFilter', function(data){
            self.toggleActivePriceFilter(data);
        });
    },
    
    parseInitialActiveFilters: function() {
        var self = this;
        var initialActiveFiltersString = $('#searchfeed').data('active-filters');
        if (initialActiveFiltersString!=""){
            initialActiveFiltersString=initialActiveFiltersString.split('&');
            _.each(initialActiveFiltersString,function(el){
                var itm = el.split('=');
                var filterValue = itm[1] == "true" ? true : parseInt(itm[1]);
                self.initialActiveFilters.push({filterType: itm[0], filterValue: filterValue});
            });
        }
    },

    throwFilterEvent: function(e){
        const item = e.currentTarget;
        const filterName = item.getAttribute("data-filter-name");
        if(!item.classList.contains('list-group-item--active')) {
            TrackingUtil.throwGAEvent(constants.TRACK_FILTER_USAGE, filterName, '', false);
        }
    },
    
    closeErrorFilter: function(e){
        e.preventDefault();
        this.$el.removeClass('tab-view__content--error');
    },
    
    getInitialFilterListByType: function(filterType){
        return _.filter(this.initialActiveFilters,{filterType: filterType});
    },
    
    clearFilters: function(){

        for (var filterType in this.listFilterViews) {
           this.listFilterViews[filterType].clearFilter();
        }
        this.activeFilters = [];
        this.manageActiveFiltersStatus();
        this.$el.find('.list-group-item--active').removeClass('list-group-item--active');
    },
    
    onActiveFilterPriceClick: function(e){
        e.preventDefault();
        var data = {
            filterType : 'price',
            filterPriceDelete: true
        };
        this.toggleActivePriceFilter(data);
    },
    
    onActiveFilterClick: function(e) {
        e.preventDefault();
        var data = {
            filterType : this.$el.find(e.currentTarget).data("filter-type"),
            filterValue : this.$el.find(e.currentTarget).data("filter-value"),
            filterName : this.$el.find(e.currentTarget).data("filter-name")
        };
        this.listFilterViews[data.filterType].onActiveFilterClick(data);
        this.toggleActiveFilter(data);
    },
    
    toggleActivePriceFilter: function(data){
        if (data.filterPriceDelete){
            
            this.activeFilters = _.reject(this.activeFilters, function(itm){ return itm.filterType == data.filterType });
            $('.js-active-filters').find('[data-filter-type="'+data.filterType+'"]').remove();
            this.listFilterViews['price'].clearFilter();
            
        }else{
            
            if (_.filter(this.activeFilters, function(itm){ return itm.filterType == data.filterType }).length){
                this.activeFilters = _.reject(this.activeFilters, function(itm){ return itm.filterType == data.filterType });
                this.activeFilters.push(data);
                $('.js-active-filters').find('[data-filter-type="'+data.filterType+'"]').remove();
                $('.js-active-filters').prepend(this.templates.ACTIVE_FILTERPRICE_TEMPLATE(data));
            }else{
                this.activeFilters.push(data);
                $('.js-active-filters').prepend(this.templates.ACTIVE_FILTERPRICE_TEMPLATE(data));
            }
        
        }
        
        this.manageActiveFiltersStatus();
    },
    
    toggleActiveFilter: function(data){
        var filterType = data.filterType;
        if (_.filter(this.activeFilters, data).length){
            this.activeFilters = _.reject(this.activeFilters,data);
            $('.js-active-filters').find('[data-filter-value="'+data.filterValue+'"]').remove();
        }else{
            this.activeFilters.push(data);
            $('.js-active-filters').prepend(this.templates.ACTIVE_FILTER_TEMPLATE(data));
            
        }
        
        this.manageActiveFiltersStatus();
        
    },
    
    manageActiveFiltersStatus: function(){
        
        if (!this.firstLoad){
            this.$el.removeClass('tab-view__content--error');
            if (this.activeFilters.length>0){
                this.applyIsActive = true;
                $('.js-filter-apply').removeClass('button--inactive').removeClass('button--grey-light').addClass('button--teal');
                $('.js-no-active-filter').hide();
            }else{
                if (this.initialActiveFilters.length==0){
                    this.applyIsActive = false;
                    $('.js-filter-apply').addClass('button--inactive').removeClass('button--teal').addClass('button--grey-light');
                }else{
                    this.applyIsActive = true;
                    $('.js-filter-apply').removeClass('button--inactive').removeClass('button--grey-light').addClass('button--teal');
                }
                $('.js-active-filter').remove();
                $('.js-active-filterprice').remove();
                $('.js-no-active-filter').show();
            }
        }else if (this.initialActiveFilters.length>0){
            $('.js-no-active-filter').hide();
        }
        
    },

    applyFilters: function(e){
        var self = this;

        if (this.applyIsActive){

            let requestPath = constants.FILTER_REQUEST_RESPONSE_URL + (this.urlParams ? "?" + this.urlParams : "");

            _.each(this.activeFilters,function(el){

                if (el.filterType === "price"){
                    requestPath = UrlUtil.addParameter(requestPath, "minPrice", el.filterPriceMin, true);
                    requestPath = UrlUtil.addParameter(requestPath, "maxPrice", el.filterPriceMax, true);
                }
                else if (el.filterType === "shop"){
                    requestPath = UrlUtil.addParameter(requestPath, "shop", el.filterValue, true);
                }
                else if (el.filterType === "brand"){
                    requestPath = UrlUtil.addParameter(requestPath, "brand", el.filterValue, true);
                }
                else if (el.filterType === "freeShipping"){
                    requestPath = UrlUtil.addParameter(requestPath, "freeShipping", "true", true);
                }
                else if (el.filterType === "sale"){
                    requestPath = UrlUtil.addParameter(requestPath, "sale", "true", true);
                }
                else{
                    requestPath = UrlUtil.addParameter(requestPath, "tag", el.filterValue, false); //there can be multiple tags
                }

            });

            ApiUtil.request({
                path: requestPath,
                success: function(data) {
                    if (data.url!=null){
                        LinkUtil.goToUrl(data.url);
                    }else{
                        TrackingUtil.throwGAEvent(constants.TRACK_MOBILE_SEARCH_BAR, 'No Results', '', false);
                        self.$el.addClass('tab-view__content--error');
                        this.applyIsActive = false;
                        $('.js-filter-apply').addClass('button--inactive').removeClass('button--teal').addClass('button--grey-light');
                    }
                }
            });

        }
    },
    
    onClickShowDropdown: function(e){
        e.preventDefault();
        this.$el.find('.list-group-item--active').not(this.$el.find(e.currentTarget).parent()).removeClass('list-group-item--active');
        this.$el.find(e.currentTarget).parent().toggleClass('list-group-item--active');
        var dropdownHeight = $(window).innerHeight() - 370;
        this.$el.find(e.currentTarget).parent().find('.js-list-dropdown').css('maxHeight',dropdownHeight);
        var contentBottomPosition = this.$el.find('.filters-tab__body').offset().top+this.$el.find('.filters-tab__body').height();
        var difference = contentBottomPosition - (this.$el.find(e.currentTarget).offset().top+dropdownHeight+80);
        if (difference<0){
            $(".filters-tab__body").animate({ scrollTop: $('.filters-tab__body').scrollTop()-difference }, 100);
        }
    },
    
    initializeFilterData: _.once(function() {
        var self = this;
        ApiUtil.request({
            path: constants.FILTER_REQUEST_DATA_URL + '?' + self.urlParams,
            success: function(data) {
                if (data.length>0){
                    JSErrorTracking.sendCustomError("Filter API Error - Data is empty");
                }

                self.filtersData = data;
                self.initializeListFilter(self.filtersData.filters.colors, '.js-color-filter', 'color');
                self.initializeListFilter(self.filtersData.filters.patterns, '.js-pattern-filter', 'pattern');
                self.initializeListFilter(self.filtersData.filters.sizes, '.js-size-filter', 'size');
                self.initializeListFilter(self.filtersData.filters.styles, '.js-style-filter', 'style');
                self.initializeListFilter(self.filtersData.filters.occasions, '.js-occasion-filter', 'occasion');
                self.initializeListFilter(self.filtersData.filters.materials, '.js-material-filter', 'material');
                self.initializeListFilter(self.filtersData.filters.brands, '.js-brand-filter', 'brand');
                self.initializeListFilter(self.filtersData.filters.rooms, '.js-room-filter', 'room');
                self.initializeListFilter(self.filtersData.filters.shops, '.js-shop-filter', 'shop');
                self.initializeListFilter(self.filtersData.filters.sunProtectionLevels, '.js-sunprotection-filter', 'sunprotection');
                self.initializeListFilter(self.filtersData.filters.scents, '.js-scent-filter', 'scent');
                self.initializeListFilter(self.filtersData.filters.ingredients, '.js-ingredient-filter', 'ingredient');
                self.initializeListFilter(self.filtersData.filters.effects, '.js-effect-filter', 'effect');
                self.initializeListFilter(self.filtersData.filters.applications, '.js-application-filter', 'application');
                self.initializeListFilter(self.filtersData.filters.specialities, '.js-specialty-filter', 'specialty');

                self.initializePriceFilter(self.filtersData.filters.price, '.js-price-filter', 'price');

                self.initializeOptionFilter(self.filtersData.filters.freeShipping,'.js-freshipping-filter','freeShipping',getI18N(jlocale.freeShippingFilter));
                self.initializeOptionFilter(self.filtersData.filters.sale,'.js-sale-filter','sale',getI18N(jlocale.saleFilter));

                self.$el.addClass('tab-view__content--loaded');
                self.firstLoad = false;
                
            },
            error: function(xhr, error){
                JSErrorTracking.sendCustomError("Filter API Error - URL not found - status:"+xhr.status);
            }
        });

    }),
    
    initializePriceFilter: function(data,bind,filterType){
        if(data !== undefined){
            this.listFilterViews[filterType] = new MobileFilterPriceView({
                el : this.$el.find(bind),
                filterData: data,
                filterType: filterType,
                initialActiveFilters: {
                    priceMin : this.getInitialFilterListByType('minPrice'),
                    priceMax : this.getInitialFilterListByType('maxPrice')
                }
            });
        }else{
            JSErrorTracking.sendCustomError("Filter API Error - Data "+bind+" is empty");
        }
    },
    
    initializeOptionFilter: function(data,bind,filterType,filterString){
        if(data !== undefined){
            
            this.listFilterViews[filterType] = new MobileFilterOptionView(
                {
                    el : this.$el.find(bind),
                    filterData: data,
                    filterType: filterType,
                    filterString: filterString,
                    initialActiveFilters: this.getInitialFilterListByType(filterType)
                });
    	}else{
            JSErrorTracking.sendCustomError("Filter API Error - Data "+bind+" is empty");
        }
    },
    
    initializeListFilter: function(data, bind, filterType) {
    	if(data !== undefined){

            this.listFilterViews[filterType] = new MobileFilterListView(
                {
                    el : this.$el.find(bind),
                    filterData: data,
                    filterType: filterType,
                    initialActiveFilters: this.getInitialFilterListByType(filterType)
                });
    	
        }else{
            JSErrorTracking.sendCustomError("Filter API Error - Data "+bind+" is empty");
        }
        
    }
    
});
